import Error from "../ComponentsGeneral/Error/ErrorPage";
import SubHeader from "../ComponentsGeneral/Navbar/SubHeader";
import { error_messages } from "../Constants/constants";

export default function HomepageError() {
  return (
    <>
      <SubHeader />
      <div className="container pt-3">
        <div className="d-flex flex-column pnl-wrapper flex-md-row py-5">
          <div className="w-100 d-flex align-items-center justify-content-center">
            <Error
              heading={error_messages.INVALID_LINK.header}
              message={error_messages.INVALID_LINK.message}
              subMessage={error_messages.INVALID_LINK.sub_message}
            />
          </div>
        </div>
      </div>
    </>
  );
}
